import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../../../../components/common-modal/CommonModal';

import scss from '../AgentList.module.scss';

function AgentInfoModal({ isOpen, onClose, agent }) {
  const { t } = useTranslation('settings');

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className={scss.modalContent}>
        <span className={scss.modalTitle}>{agent?.name}</span>

        <div className={scss.modalLabel}>{t('instructions')}:</div>

        <span className={scss.modalInstruction}>{agent?.instructions}</span>
      </div>
    </CommonModal>
  );
}

export default AgentInfoModal;
